export default __webpack_public_path__ + "images/MV.1f10bf0.png";